// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider {
  cursor: pointer;
  position: absolute;
  z-index: 1;
}
.slider .thick-bar {
  background-color: #009ADF;
  border-radius: 3px;
  height: 60%;
  position: absolute;
  top: 20%;
  left: -3px;
  width: 6px;
}
.slider .thin-bar {
  background-color: #009ADF;
  height: 100%;
  position: absolute;
  top: 1px;
  width: 1px;
}
.slider .touch-target {
  position: absolute;
  left: -25px;
  width: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modals/charts-modal/ChartSlider.vue","webpack://./ChartSlider.vue"],"names":[],"mappings":"AACM;EACI,eAAA;EACA,kBAAA;EACA,UAAA;ACAV;ADHM;EAKQ,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;ACCd;ADZM;EAcQ,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;ACCd;ADnBM;EAqBQ,kBAAA;EACA,WAAA;EACA,WAAA;ACCd","sourcesContent":["\n      .slider {\n          cursor: pointer;\n          position: absolute;\n          z-index: 1;\n          .thick-bar {\n              background-color: #009ADF;\n              border-radius: 3px;\n              height: 60%;\n              position: absolute;\n              top: 20%;\n              left: -3px;\n              width: 6px;\n          }\n          .thin-bar {\n              background-color: #009ADF;\n              height: 100%;\n              position: absolute;\n              top: 1px;\n              width: 1px;\n          }\n          .touch-target {\n              position: absolute;\n              left: -25px;\n              width: 50px;\n          }\n      }\n  ",".slider {\n  cursor: pointer;\n  position: absolute;\n  z-index: 1;\n}\n.slider .thick-bar {\n  background-color: #009ADF;\n  border-radius: 3px;\n  height: 60%;\n  position: absolute;\n  top: 20%;\n  left: -3px;\n  width: 6px;\n}\n.slider .thin-bar {\n  background-color: #009ADF;\n  height: 100%;\n  position: absolute;\n  top: 1px;\n  width: 1px;\n}\n.slider .touch-target {\n  position: absolute;\n  left: -25px;\n  width: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
